import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      background: theme.oysterTheme.pine,
      padding: '20px 153px 20px 115px',
      [theme.breakpoints.down('sm')]: {
        padding: '0 16px',
      },
    },
    firstSection: { padding: '19px 0 21px 0' },
    adicionalInfo: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      fontSize: '14px',
      color: theme.oysterTheme.cotton,
    },
    oysterLogo: {
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    topic: {
      display: 'block',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
      fontSize: '18px',
      color: theme.oysterTheme.pearl,
    },
    link: {
      display: 'block',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      fontSize: '14px',
      color: theme.oysterTheme.dolphin,
      marginTop: '16px',
      '&:hover': {
        textDecoration: 'none',
      },
    },
    secondSection: {
      borderTop: `1px solid ${theme.oysterTheme.cotton}`,
      padding: '16px 0',
    },
    socialMedia: {
      justifyContent: 'flex-end',
    },
    socialMediaIcons: {
      display: 'flex',
      marginLeft: 16,
      columnGap: 24,
      [theme.breakpoints.down('xs')]: {
        columnGap: 16,
        marginLeft: 8,
      },
    },
  }),
);

export default useStyles;
